import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';

/**
 * ProgressBar is used to display the user's progress toward completing a set of tasks.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/progress-bar#usage)
 * - [Props](https://blockparty.endpoint.com/components/progress-bar#props)
 * <br />
 *
 */
const ProgressBar = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    completed,
    steps,
    barColor = 'turquoise500',
    dataTestId = 'progress-bar',
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    "aria-valuemax": steps,
    "aria-valuemin": 0,
    "aria-valuenow": completed,
    bg: "slate100"
    // matches figma value
    ,
    borderRadius: "10px",
    "data-test-id": dataTestId,
    height: "4px",
    overflow: "hidden",
    position: "relative",
    role: "progressbar"
  }, rest), /*#__PURE__*/React__default.createElement(Box, {
    bg: barColor,
    "data-test-id": "progress-bar-inner",
    height: "100%",
    transition: "fast",
    transitionProperty: "width",
    width: completed === 0 ? '16px' : `${completed / steps * 100}%`
  }));
});
ProgressBar.displayName = 'ProgressBar';

export { ProgressBar };
